export const shipxCloudMenus = () => ({
    id: `coln-1-collections`,
    label: 'ShipX Cloud',
    path: '/management/shipx-cloud/shipx-agency-mappings',
    isEnabled: true,
    svg: (
      <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#ffffff"></path>
        </g>
      </svg>
  
    ),
    subMenu: [
          {
            id: `coln-1-collections`,
            label: 'ShipX Agencies Mapping ',
            path: '/management/shipx-cloud/shipx-agency-mappings',
            isEnabled: true,
            svg: (
              <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                </g>
              </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'ShipX Agencies Registries',
            path: '/management/shipx-cloud/shipx-agency-registries',
            isEnabled: true,
            svg: (
              <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                </g>
              </svg>
      
            ),
          },

           {
            id: `coln-1-collections`,
            label: 'Onboard Registries',
            path: '/management/shipx-cloud/onboard-shipx-agency-registries',
            isEnabled: true,
            svg: (
              <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#007BFF"></path>
                </g>
              </svg>
      
            ),
              subMenu: [
         {
          id: `coln-1-collections`,
          label: 'My Agencies',
          path: '/management/shipx-cloud/shipx-registries/my-agencies',
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M20 3h-3V2H7v1H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
          isEnabled: true,
        },
        {
          id: `coln-1-collections`,
          label: 'Find Agencies',
          path: '/management/shipx-cloud/onboard-shipx-agency-registries',
          svg: (
            <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fillRule="evenodd" clipRule="evenodd" d="M20 3h-3V2H7v1H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
              </g>
            </svg>

          ),
          isEnabled: true,
        },
       
      ]
          },
         
        ]}
)